import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=7086dc8f&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Comments.vue?vue&type=style&index=0&id=7086dc8f&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7086dc8f",
  "60b2947e"
  
)

export default component.exports